import React, { useState, useRef } from "react";

import { PageFrame } from "components/auth/PageFrame";
import {
  Grid,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { resetToNewPassword } from "libLegacy/api/auth";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const PAGE_DATA = {
  title: "Criar nova senha",
  buttonText: "Redefinir senha",
  nextTo: "/auth/reset-success",
};

export const NewPassword = ({ match: { params }, history }) => {
  const { title, buttonText, nextTo } = PAGE_DATA;
  const refPassword = useRef<HTMLInputElement>(null);
  const refConfirmationPassword = useRef<HTMLInputElement>(null);
  const [hidePassword, setHidePassword] = useState(true);
  const [hidePasswordConfirmation, setHidePasswordConfirmation] =
    useState(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const setGlobalError = useSetError();
  const errorInfo = useErrorInfo();
  const hasFormError = errorInfo?.code === CustomCodes.INVALID_FORM;

  const handleClick = async () => {
    const password = refPassword.current?.value;
    const confirmationPassword = refConfirmationPassword.current?.value;

    if (password?.length && password === confirmationPassword) {
      setIsLoading(true);
      try {
        const { resetID, verification } = params;
        await resetToNewPassword(resetID, password, verification);
        history.push(nextTo);
      } catch (error) {
        // @ts-expect-error
        setGlobalError(error.response?.data?.error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setGlobalError(CustomCodes.INVALID_FORM);
    }
  };

  const toggleVisibility = () => {
    setHidePassword((prev) => !prev);
  };

  const togglePasswordConfirmationVisibility = () => {
    setHidePasswordConfirmation((prev) => !prev);
  };

  const passwordIcon = (
    <InputAdornment position="end">
      <IconButton onClick={toggleVisibility}>
        {hidePassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
      </IconButton>
    </InputAdornment>
  );

  const passwordConfirmationIcon = (
    <InputAdornment position="end">
      <IconButton onClick={togglePasswordConfirmationVisibility}>
        {hidePasswordConfirmation ? <VisibilityOffIcon /> : <VisibilityIcon />}
      </IconButton>
    </InputAdornment>
  );

  return (
    <PageFrame
      title={title}
      centerText
      buttonData={{
        text: isLoading ? (
          <CircularProgress size={24} color="secondary" />
        ) : (
          buttonText
        ),
        onClick: handleClick,
      }}
    >
      <Grid container gap={4}>
        <TextField
          inputRef={refPassword}
          variant="outlined"
          label="Sua nova senha"
          InputProps={{ endAdornment: passwordIcon }}
          type={hidePassword ? "password" : "text"}
          fullWidth
        />
        <TextField
          inputRef={refConfirmationPassword}
          variant="outlined"
          label="Repita sua nova senha"
          InputProps={{ endAdornment: passwordConfirmationIcon }}
          type={hidePasswordConfirmation ? "password" : "text"}
          fullWidth
          error={hasFormError}
        />
      </Grid>
    </PageFrame>
  );
};
